// extracted by mini-css-extract-plugin
var _1 = "dISzndj0SvxxdXa0ccMk";
var _2 = "zPakbSRRo6w8V1TqT6FB";
export { _1 as "error", _2 as "infoText" }
